import React from 'react';
import { Link } from 'react-router-dom';
import logoimg from '../../assets/images/kplot-logo-white.png'
import { RiInstagramFill, RiFacebookFill, RiYoutubeFill, RiLinkedinFill, RiHeart3Line } from "react-icons/ri";
import esightLogo from '../../assets/images/esight-logo-white.png'

function Footer() {
  return (
    <>
        <footer>
            <div className="container">
                <div className="footerMain">
                    <div className="footerCol1">
                        <div className="footerLogo">
                            <img src={logoimg} alt="" />
                        </div>
                        <p>Keralaplots.com is a new real estate platform that makes it easier to find your new property without paying any brokerage. Use our verified listing to ensure you find your dream property by contacting the owners directly.</p>
                        <div className="footerSocialLinks">
                            <Link to="https://www.instagram.com/keralaplots/" target='_blank'><RiInstagramFill /></Link>
                            <Link to="https://www.facebook.com/keralaplots?mibextid=ZbWKwL" target='_blank'><RiFacebookFill /></Link>
                            <Link to="https://youtube.com/@keralaplots1373?si=u5D93SxSFwQ-FmgW" target='_blank'><RiYoutubeFill /></Link>
                            <Link to="https://www.linkedin.com/in/kerala-plots-1a34b6249" target='_blank'><RiLinkedinFill /></Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footerStrip">
                <div className="container">
                    <div className="footerStripMain">
                        <div className="footerStripBox">
                            <p>Copyright © {new Date().getFullYear()} Kerala Plots. All Rights Reserved.</p>
                        </div>
                        <div className="footerStripBox">
                            <p>Designed with</p>
                            <RiHeart3Line />
                            <Link to="https://esightsolutions.com/" target="_blank" className="footerStripLogo">
                                <img src={esightLogo} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </>
  );
}

export default Footer;
